import { useTracker } from 'framework-listing-lib/internal/providers/TrackerProvider';
export default function useApplicationId() {
  const {
    applicationId
  } = useTracker();
  return applicationId;
}